import React, { useState, useEffect } from "react";
import Address from "./address"; // 引用 Address 元件

function EditableAddress({ initialAddress, onAddressChange }) {
    const [isEditing, setIsEditing] = useState(false);
    const [currentAddress, setCurrentAddress] = useState(initialAddress);

    // 當 initialAddress 改變時，更新 currentAddress
    useEffect(() => {
        setCurrentAddress(initialAddress);
    }, [initialAddress]);

    const handleAddressChange = (newAddress) => {
        setCurrentAddress(newAddress);
        onAddressChange(newAddress); // 通知父元件更新
    };

    return (
        <div>
            {isEditing ? (
                <Address
                    initialAddress={currentAddress}
                    onAddressChange={handleAddressChange}
                    onBlur={() => setIsEditing(false)} // 只有在失去焦點時才退出編輯模式
                />
            ) : (
                <input
                    type="text"
                    value={currentAddress}
                    readOnly
                    className="form-control"
                    onClick={() => setIsEditing(true)} // 點擊進入編輯模式
                />
            )}
        </div>
    );
}

export default EditableAddress;